import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import PatientDetailDrawer from '../../features/patients/PatientDetailDrawer';
import { InvoiceDetailModal } from '../../features/billing/BillingPage';
import {
  selectOpenPatientId, selectOpenInvoiceId, closePatientDetail, closeInvoiceDetail,
} from '../../features/ui/detailPanelSlice';

export default function AppShell() {
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const openPatientId = useSelector(selectOpenPatientId);
  const openInvoiceId = useSelector(selectOpenInvoiceId);

  return (
    <div className="app-shell">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
      <div className={`main-area ${collapsed ? 'sidebar-collapsed' : ''}`}>
        <Topbar onToggleSidebar={() => setCollapsed((c) => !c)} />
        <main className="page-body">
          <Outlet />
        </main>
      </div>

      {/* Mounted once, above every routed page (sibling to <Outlet/>) — opening a patient or
          invoice from anywhere (global search, Today's Tasks, call logs, the calendar popover…)
          overlays here WITHOUT changing the route, so the page underneath is never unmounted and
          keeps its filters/search/scroll exactly as the user left them. See detailPanelSlice.js. */}
      {openPatientId && (
        <PatientDetailDrawer patientId={openPatientId} onClose={() => dispatch(closePatientDetail())} />
      )}
      {openInvoiceId && (
        <InvoiceDetailModal invoiceId={openInvoiceId} onClose={() => dispatch(closeInvoiceDetail())} />
      )}
    </div>
  );
}
